import React, { useEffect } from 'react';
import { Avatar, Icon } from '@webiz/admin-design-system';
import { Col, Row, Checkbox, Typography, Dropdown, Menu } from 'antd';
import { DashboardIcon, NextPayout, PaymentIcon, UsersIcon } from '../Icon';
import DateRangePicker from '../DateRangePicker';
import { Dispatch } from "redux";
import { useDispatch, useSelector } from 'react-redux';
import { getUser, logOut } from '../../store/auth/AuthServices';
import { getNextPayout } from '../../store/payments';

const { Text, Paragraph } = Typography;

const HeaderContent = ({ setCheckbox, checkbox }: any) => {
  const user = useSelector((state: any) => state.auth.user);
  const nextPayout = useSelector((state: any) => state.payments.nextPayout);
  const main = useSelector((state: any) => state.main.title);
  const dispatch: Dispatch<any> = useDispatch();

  const handleLogOut = () => {
    dispatch(logOut());
  }

  useEffect(() => {
      dispatch(getUser());
      dispatch(getNextPayout());
  }, [dispatch]);

  return (
    <>
      <Row>
        <Col className="header">
          <Col className="header-leftside">
            <Col className="header-content-title">
              {main?.icon === 'Dashboard' ? (
                <>
                  <DashboardIcon color="#2F80ED" />
                  <Text className="header-config">{main.label}</Text>
                </>
              ) : main.icon === 'Users' ? (
                <>
                  <UsersIcon color="#2F80ED" />
                  <Text className="header-config">{main.label}</Text>
                </>
              ) : main.icon === 'Payments' ? (
                <>
                  <PaymentIcon color="#2F80ED" />
                  <Text className="header-config">{main.label}</Text>
                </>
              ) : null}
            </Col>
            <Col>
              <DateRangePicker checkbox={checkbox} setCheckbox={setCheckbox} />
            </Col>
            <Col className="all-time-checkbox-cont">
              <span className="all-time-checkbox-title">All Time</span>
              <Checkbox
                checked={checkbox[1]}
                onChange={(st) => setCheckbox([false, true])}
              />
            </Col>
          </Col>
          <Col className="header-rightside">
            <Col className="header-info">
              <Text className="text-style">Next Payout</Text>
              <span style={{ margin: "0 16px", display: "flex" }}>
                <NextPayout />
              </span>
              {nextPayout && nextPayout.map((obj: any, index: number) => obj?.currency === 'ILS' && <Text key={index} className="text-style">{`₪ ${parseFloat(obj?.total)?.toFixed(2)}`}</Text>)}
            </Col>
            <div className="header-account">
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="logout"
                      onClick={handleLogOut}
                    >
                      <Icon
                        name="LogOut"
                        className="header-icon"
                      />
                      logout
                    </Menu.Item>
                  </Menu>
                }
                overlayClassName="header-account-dropdown"
                placement="bottomRight"
                arrow
              >
                <div className="header-account-content">
                  <Avatar
                    className="avatar"
                    size="xs"
                    avatarUrl={user && user.avatar}
                  />
                  <Text>
                    <Paragraph
                      ellipsis={{ tooltip: true }}
                      className="header-truncate-tooltip"
                    >
                      {" "}
                      {user && user.name}
                    </Paragraph>
                    <Icon
                      name="HeaderDropdown"
                      className="header-dropdown-icon"
                    />
                  </Text>
                </div>
              </Dropdown>
            </div>
          </Col>
        </Col>
      </Row>
    </>
  );
};

export default HeaderContent;
